module.exports = __webpack_public_path__ + "img/5.62540237.jpg";